exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delivery-note-create-page .item-table .item-body .item-row td[data-v-4fc59d48] {\n  padding-left: 0px !important;\n}\n", ""]);

// exports
